import { render } from "./ResetPasswordBody.vue?vue&type=template&id=009e5130&scoped=true"
import script from "./ResetPasswordBody.vue?vue&type=script&lang=js"
export * from "./ResetPasswordBody.vue?vue&type=script&lang=js"

import "./ResetPasswordBody.vue?vue&type=style&index=0&id=009e5130&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-009e5130"]])

export default __exports__